<script setup lang="ts">
/**
 * Theme card (New capsule flow; Quizzes: Lifestyle, Gift, Outfit). White card,
 * hairline frame, 20px line icon + label; Selected draws the frame in primary.
 * Single choice — `role="radio"`, multi choice — `role="checkbox"`.
 */
import { computed } from 'vue'
import { fairThemeIconSvg } from './fairThemeIcons'

interface FairThemeCardProps {
  label: string
  description?: string
  /** File name in `assets/quiz/icons` (office, study, …). */
  icon?: string
  selected?: boolean
  multi?: boolean
  disabled?: boolean
}

const props = withDefaults(defineProps<FairThemeCardProps>(), {
  description: '',
  icon: '',
  selected: false,
  multi: false,
  disabled: false,
})

const emit = defineEmits<{
  click: [event: MouseEvent]
}>()

const iconSvg = computed(() => (props.icon ? fairThemeIconSvg(props.icon) : ''))
</script>

<template>
  <button
    type="button"
    class="fair-theme-card"
    :class="{ 'fair-theme-card--selected': selected }"
    :role="multi ? 'checkbox' : 'radio'"
    :aria-checked="selected"
    :disabled="disabled"
    @click="emit('click', $event)"
  >
    <!-- eslint-disable vue/no-v-html — bundled SVG from assets/quiz/icons -->
    <span
      v-if="iconSvg"
      class="fair-theme-card__icon"
      aria-hidden="true"
      v-html="iconSvg"
    />
    <!-- eslint-enable vue/no-v-html -->
    <span class="fair-theme-card__text">
      <span class="fair-theme-card__label">{{ label }}</span>
      <span
        v-if="description"
        class="fair-theme-card__description"
      >{{ description }}</span>
    </span>
  </button>
</template>
